import React, { useState } from "react";
import {
  Typography,
  IconButton,
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BulkUpdateDialog from "../../../../components/BulkUpdateDialog";
import {
  AccordionDetailsStyled,
  AccordionStyled,
  AccordionSummaryStyled,
} from "../../components/mui/Accordions/StyledAccordion/StyleAccordion";

const ReactionsAccordion = ({
  expanded,
  onChange,
  problemReactions,
  handleAddReaction,
  handleDeleteReaction,
  handleReactionChange,
  reactions,
  setProblemData,
}) => {
  const [openDialog, setOpenDialog] = useState(false);

  const validateReactions = (parsedReactions) => {
    parsedReactions.forEach((reaction, index) => {
      if (!reaction.count || !reaction.reaction) {
        throw new Error(
          `Reaction at index ${index} is missing count or reaction`
        );
      }
    });
  };

  const handleBulkUpdateReactions = (parsedReactions) => {
    setProblemData((prev) => {
      const updatedReactions = parsedReactions.map((reaction) => ({
        count: reaction.count,
        reaction: reaction.reaction,
      }));
      return {
        ...prev,
        problemReactions: updatedReactions.length > 0 ? updatedReactions : null,
      };
    });
  };

  return (
    <>
      <AccordionStyled expanded={expanded} onChange={onChange}>
        <AccordionSummaryStyled
          expandIcon={<ExpandMoreIcon />}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" sx={{ alignSelf: "center" }}>
            Reactions
          </Typography>
          {expanded && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenDialog(true);
                }}
              >
                Bulk Update
              </Button>
              <IconButton
                color="#475259"
                aria-label="Add Reaction"
                onClick={handleAddReaction}
                disabled={!expanded}
              >
                <AddIcon />
              </IconButton>
            </Box>
          )}
        </AccordionSummaryStyled>
        <AccordionDetailsStyled>
          {problemReactions && problemReactions.length > 0 ? (
            problemReactions.map((reaction, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  mb: 2,
                  justifyContent: "space-between",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <TextField
                    name="count"
                    label="Count"
                    placeholder="Enter reaction count"
                    value={reaction.count || ""}
                    onChange={(e) =>
                      handleReactionChange(index, "count", e.target.value)
                    }
                    type="number"
                  />
                  <Select
                    value={reaction.reaction || ""}
                    onChange={(e) =>
                      handleReactionChange(index, "reaction", e.target.value)
                    }
                    displayEmpty
                    sx={{ minWidth: 200 }}
                  >
                    <MenuItem value="" disabled>
                      Select a Reaction
                    </MenuItem>
                    {reactions.map((r) => (
                      <MenuItem key={r.key} value={r.key}>
                        {r.value}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
                <IconButton
                  color="error"
                  aria-label="Delete Reaction"
                  onClick={() => handleDeleteReaction(index)}
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            ))
          ) : (
            <Typography>No reactions available</Typography>
          )}
        </AccordionDetailsStyled>
      </AccordionStyled>

      <BulkUpdateDialog
        title="Bulk Update Reactions"
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onBulkUpdate={handleBulkUpdateReactions}
        validateInput={validateReactions}
        successMessage="Reactions added successfully!"
        helperText="Enter an array of reactions in JSON format (e.g.,[{
            'count': 1,
            'reaction': 'LIKE'
        }],"
      />
    </>
  );
};

export default ReactionsAccordion;
